module.exports = __webpack_public_path__ + "img/1F1F2-1F1E9.c4ef819b.svg";